























































































































































































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import {
  InvestmentCustodian,
  FeatureFlags,
  HsabSsoDestination
} from "@/shared/types";
import * as RouteNames from "@/employee/route-names";
import ValueBadge from "@/shared/components/ui/ValueBadge.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import HsabInvestmentRedirectPage from "@/employee/components/investments/HsabInvestmentRedirectPage.vue";
import { isMobileApp } from "@/shared/mobileHelper";
import { useUserStore } from "@/shared/store/user";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";
import { useNavigationStore } from "@/shared/store/navigation";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useHsabInvestmentStore } from "@/shared/store/hsabInvestment";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";

const dashboardNavItem = "dashboard";
const balancesNavItem = "balancesActions";
const contributionPlannerNavItem = "contributionPlannerActions";
const resourcesNavItem = "resources";
const changePlansNavItem = "changePlans";
const healthcareExpensesNavItem = "healthcareExpenses";
const settingsNavItem = "settings";
const investNavItem = "invest";
const contributionActionsNavItem = "contributionsActions";
const productScannerNavItem = "productScanner";
const notionalDashboardNavItem = "notional-dashboard";

@Component({
  components: {
    ValueBadge,
    SsoDeepLink,
    HsabInvestmentRedirectPage
  }
})
export default class NavV2 extends Vue {
  userStore = useUserStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();
  navigationStore = useNavigationStore();
  custodianSettingsStore = useCustodianSettingsStore();
  bankAccountStore = useBankAccountStore();
  featureFlagStore = useFeatureFlagStore();
  hsabInvestmentStore = useHsabInvestmentStore();
  hsabAccountsStore = useHsabAccountsStore();
  investmentThresholdStore = useInvestmentThresholdStore();

  afterRoutedHook: any;

  RouteNames = RouteNames;

  @Prop()
  open: boolean;

  navItemActive = "";

  selectNavItem (itemName: string) {
    this.navItemActive = itemName;
  }

  closeNav () {
    this.navigationStore.closeMobileMenu();
  }

  get isEverythingLoaded () {
    return this.custodianSettingsStore.isLoaded && this.featureFlagStore.featureFlagsAvailable;
  }

  get showDashboardLink (): boolean {
    if (this.userStore.isNotionalDashboardActive) {
      return false;
    }
    const { Home, Dashboard } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Home] || this.custodianSettingsStore.disabledRoutes[Dashboard]) {
      return false;
    }

    return true;
  }

  get investmentIcon (): string {
    if (this.custodianSettingsStore.isHsaBankCustodian) {
      return "fa-solid fa-arrow-up-right-from-square";
    }

    return "fa-solid fa-chart-area";
  }

  get showCashAccountLink (): boolean {
    if (this.userStore.isNotionalDashboardActive) {
      return false;
    }
    const { CashBalance } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[CashBalance]) {
      return false;
    }

    return true;
  }

  get hsabDeepLinkDashboard () {
    return HsabSsoDestination.Dashboard;
  }

  get hsabDeepLinkPayment () {
    return HsabSsoDestination.DistributeFund;
  }

  get hsabDeepLinkMessageCenter () {
    return HsabSsoDestination.MessageCenter;
  }


  get showNewClaims (): boolean {
    return this.custodianSettingsStore.displayNewHealthcareExpenses &&
        this.custodianSettingsStore.showHealthcareExpensesV2;
  }

  get hsabDeepLinkFileClaim () {
    return HsabSsoDestination.FileClaim;
  }

  get showContributionsLink (): boolean {
    if (this.userStore.isNotionalDashboardActive) {
      return false;
    }
    const { Contribution } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Contribution]) {
      return false;
    }

    return true;
  }

  get showContributionPlannerLink (): boolean {
    if (this.userStore.isNotionalDashboardActive) {
      return false;
    }
    const { ContributionPlanner } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[ContributionPlanner]) {
      return false;
    }

    return true;
  }

  get showResourcesLink (): boolean {
    if (this.userStore.isNotionalDashboardActive) {
      return false;
    }
    const { Resources } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Resources]) {
      return false;
    }

    return true;
  }

  get showSettingsLink (): boolean {
    const { Settings } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Settings]) {
      return false;
    }

    return true;
  }

  get showProductScannerLink () {
    if (this.userStore.isNotionalDashboardActive || this.bankAccountStore.isBankAccountClosed) {
      return false;
    }

    return isMobileApp();
  }

  get settingsUrl (): string {
    if (this.custodianSettingsStore.displaySettingsLinkedAccounts && !this.userStore.isNotionalDashboardActive) {
      return "/settings";
    }

    return "/settings/my-profile";
  }

  get showReimburseLink (): boolean {
    return this.custodianSettingsStore.allowReimbursement && !this.bankAccountStore.isBankAccountClosed;
  }

  get userProfileLinkActive () {
    return this.navItemActive === "userProfile";
  }

  get dashboardLinkActive () {
    return this.navItemActive === dashboardNavItem;
  }

  get notionalDashboardLinkActive () {
    return this.navItemActive === notionalDashboardNavItem;
  }

  get balancesLinkActive () {
    return this.navItemActive === balancesNavItem;
  }

  get healthcareLinkActive () {
    return this.navItemActive === healthcareExpensesNavItem;
  }

  get contributionsLinkActive () {
    return this.navItemActive === "contributions";
  }

  get contributionPlannerLinkActive () {
    return this.navItemActive === "contributionPlanner";
  }

  get investLinkActive () {
    return this.navItemActive === investNavItem;
  }

  get settingsLinkActive () {
    return this.navItemActive === settingsNavItem;
  }

  get productScannerLinkActive () {
    return this.navItemActive === productScannerNavItem;
  }

  get changePlansLinkActive () {
    return this.navItemActive === changePlansNavItem;
  }

  get resoursesLinkActive () {
    return this.navItemActive === resourcesNavItem;
  }

  get showInvestmentsLink () {
    if (this.userStore.isNotionalDashboardActive) {
      return false;
    }
    if (!this.custodianSettingsStore.displayInvestmentsSection) {
      return false;
    }

    const { InvestmentAccountInfo } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[InvestmentAccountInfo]) {
      return false;
    }

    if (this.custodianSettingsStore.investmentCustodian === InvestmentCustodian.HsaBank) {
      const hsabDrivewealthEnabled = (this.investmentThresholdStore.isDrivewealthInvestmentProvider &&
          this.featureFlagStore.flags.bend15244DisplayDrivewealthInvestmentForHSABUsers);

      return this.hsabInvestmentStore.hsabInvestmentsEnabled || hsabDrivewealthEnabled;
    }

    return this.custodianSettingsStore.investmentCustodian !== InvestmentCustodian.Tda
        || this.featureFlagStore.flags.showTdaInvestmentLink;
  }

  get showLegacyHsabInvestmentsRedirectLink (): boolean {
    return (!this.featureFlagStore.flags.bend15244DisplayDrivewealthInvestmentForHSABUsers &&
        this.custodianSettingsStore.investmentCustodian === InvestmentCustodian.HsaBank &&
        this.hsabInvestmentStore.hsabInvestmentsEnabled);
  }

  get showDrivewealthLink (): boolean {
    if (this.custodianSettingsStore.investmentCustodian === InvestmentCustodian.HsaBank) {
      return this.featureFlagStore.flags.bend15244DisplayDrivewealthInvestmentForHSABUsers;
    }

    return true;
  }

  created () {
    this.expenseBalanceSummaryStore.loadState();
    this.afterRoutedHook = this.$router.afterEach(this.closeNav);
    this.custodianSettingsStore.getCustodianSettings();
    this.bankAccountStore.getBankAccountStatus();

    const routesToNavItems = {};
    routesToNavItems[RouteNames.Home] = dashboardNavItem;
    routesToNavItems[RouteNames.CashBalance] = balancesNavItem;
    routesToNavItems[RouteNames.Contribution] = contributionActionsNavItem;
    routesToNavItems[RouteNames.ContributionPlanner] = contributionPlannerNavItem;
    routesToNavItems[RouteNames.Resources] = resourcesNavItem;
    routesToNavItems[RouteNames.HsabAccountSelection] = changePlansNavItem;

    const currentRouteName = this.$router.currentRoute.name;
    const navItem = routesToNavItems[currentRouteName];
    if (navItem) {
      this.selectNavItem(navItem);
      return;
    }

    const pathStartToNavItems = {
      "/healthcare-expenses": healthcareExpensesNavItem,
      "/settings": settingsNavItem,
      "/investment-account": investNavItem
    };

    const routePath = this.$router.currentRoute.path;
    for (const pathStart in pathStartToNavItems) {
      if (routePath.startsWith(pathStart)) {
        this.selectNavItem(pathStartToNavItems[pathStart]);
        return;
      }
    }
  }

  beforeDestroy () {
    this.afterRoutedHook();
  }
}

